module.exports = "../../../../platform/assets/pageMainIcon/icon-shuzhi-1-yellow.svg";